export default "__VITE_ASSET__bdd4afe2__"